import React from "react"
import { Flame, Check } from "lucide-react"

const StreakTracker = ({ streak = 0, hasCheckedInToday = false, handleIncreaseStreak }) => {
	// Calculate streak days for visual display
	const streakDays = [
		{ day: "1", completed: streak >= 1 },
		{ day: "2", completed: streak >= 2 },
		{ day: "3", completed: streak >= 3 },
		{ day: "4", completed: streak >= 4 },
		{ day: "5", completed: streak >= 5 },
		{ day: "6", completed: streak >= 6 },
		{ day: "7", completed: streak >= 7 },
	]

	return (
		<div className='bg-[#1E1E1E] rounded-lg p-4'>
			<div className='flex flex-col sm:flex-row sm:items-center justify-between mb-3'>
				<div className='flex items-center mb-2 sm:mb-0'>
					<div className='bg-[#2C2C2C] p-2 rounded-full mr-3'>
						<Flame className='text-[#FF3A6E]' size={20} />
					</div>
					<div>
						<h3 className='text-white font-semibold'>Daily Streak</h3>
						<p className='text-[#A0A0A0] text-sm'>
							{streak > 0
								? `${streak} day${streak > 1 ? "s" : ""} streak! Keep it up!`
								: "Start your learning streak today!"}
						</p>
					</div>
				</div>
				<div className='bg-[#2C2C2C] px-3 py-1 rounded-full self-start sm:self-auto'>
					<span className='text-white font-bold'>{streak}</span>
					<span className='text-[#FF3A6E] ml-1'>🔥</span>
				</div>
			</div>

			{/* Streak days visualization */}
			<div className='flex justify-between items-center'>
				{streakDays.map((item, index) => (
					<div
						key={index}
						className={`flex flex-col items-center justify-center w-6 sm:w-8 h-6 sm:h-8 rounded-full 
            ${
								item.completed
									? "bg-[#FF3A6E]"
									: index === streak % 7
									? "bg-[#2C2C2C] border border-[#FF3A6E] border-dashed"
									: "bg-[#2C2C2C]"
							}`}>
						<span
							className={`text-xs font-medium ${
								item.completed ? "text-white" : "text-[#A0A0A0]"
							}`}>
							{item.day}
						</span>
					</div>
				))}
			</div>

			{/* Check-in button with different states */}
			<div className='mt-3'>
				{hasCheckedInToday ? (
					<button
						className='bg-green-600 text-white text-xs sm:text-sm py-2 px-4 rounded-lg w-full flex items-center justify-center cursor-default'
						disabled
					>
						<Check size={16} className='mr-2' />
						Checked in today!
					</button>
				) : (
					<button
						className='bg-[#FF3A6E] text-white text-xs sm:text-sm py-2 px-4 rounded-lg w-full hover:bg-[#ff2a5e] transition-colors'
						onClick={handleIncreaseStreak}
					>
						Check in today
					</button>
				)}
			</div>
		</div>
	)
}

export default StreakTracker